import login from '@/views/login'
import main from '@/views/main'
import my from '@/views/tabs/my'
import home from '@/views/tabs/home'
import layout from '@/views/tabs/layout'

export const routes =
    [
        {
            path: '/',
            redirect: "/login"
        },
        {
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '/main',
            name: 'main',
            component: main,
            children: [
                {
                    path: 'my',
                    name: 'my',
                    component: my
                },
                {
                    path: 'home',
                    name: 'home',
                    component: home,
                },
                {
                    path: 'layout',
                    name: 'layout',
                    component: layout
                },
            ]
        },
    ]



// WEBPACK FOOTER //
// ./src/router/routes.js